import styled from 'styled-components'

import { fonts, palette } from '../../../../styles/variables'
import { getLanguageCode, translate } from '../../../../utils/translation'
import { ReactComponent as ArrowLeft } from '../../../../styles/assets/checkoutModal/arrow-left.svg'
import { ReactComponent as ArrowRight } from '../../../../styles/assets/checkoutModal/arrow-right.svg'
import { ReactComponent as EllipseIcon } from '../../../../styles/assets/checkoutModal/ellipse.svg'
import { ReactComponent as CheckMark } from '../../../../styles/assets/checkoutModal/checkmark.svg'
import { Text } from '../../../topography'
import { formatNumber } from '../../../../utils/numbers'

const Wrapper = styled.div({
  border: `1px solid ${palette.gray10}`,
  width: '100%',
  borderRadius: '2px',
  flexGrow: 1,
})

const Header = styled.div({
  borderBottom: `1px solid ${palette.gray10}`,
  backgroundColor: palette.lightGray10,
  padding: '0px 12px',
  height: '44px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
})

const ArrowButton = styled.div(({ disabled }) => ({
  width: '28px',
  height: '28px',
  borderRadius: '14px',
  border: `1px solid ${disabled ? palette.lightGray30 : palette.lightGray50}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: disabled ? 'default' : 'pointer',
  flexShrink: 0,
  backgroundColor: palette.white,
  '&:hover': {
    borderColor: disabled ? palette.lightGray30 : palette.orange,
    backgroundColor: disabled ? palette.white : palette.orange10,
    svg: {
      stroke: disabled ? palette.lightGray30 : palette.orange,
    },
  },
  svg: {
    stroke: disabled ? palette.lightGray30 : palette.darkGray,
  },
}))

const HeaderText = styled.div({
  fontFamily: fonts.primary,
  fontSize: '16px',
  lineHeight: '16px',
  color: palette.darkGray,
  display: 'flex',
  alignItems: 'center',
  fontWeight: 'bold',
  padding: '0px 16px',
})

export default ({ tier, onChange }) => {
  const lang = getLanguageCode()
  const PLANS = {
    tier1: {
      title: translate('individual'),
      description: translate('choose_individual_subheading'),
      lists: [
        translate('one_user'),
        translate('n_domains', formatNumber(1)),
        translate('n_searches_day', formatNumber(150)),
        translate('competitor_per_domain', formatNumber(5)),
        translate('scans_per_domain', formatNumber(1000)),
        translate('kw_per_domain', formatNumber(125)),
        translate('locations_per_domain', formatNumber(20)),
        translate('yes_export_img_csv_pdf'),
      ],
    },
    tier2: {
      title: translate('plans_business'),
      description: translate('choose_business_subheading'),
      lists: [
        translate('n_users', formatNumber(2)),
        translate('n_domains', formatNumber(7)),
        translate('n_searches_day', formatNumber(300)),
        translate('competitor_per_domain', formatNumber(10)),
        translate('scans_per_domain', formatNumber(5000)),
        translate('kw_per_domain', formatNumber(150)),
        translate('unlimited_locations_per_domain'),
        translate('yes_export_img_csv_pdf'),
      ],
    },
    tier3: {
      title: translate('enterprise'),
      description: translate('choose_enterprise_subheading'),
      lists: [
        translate('n_users', formatNumber(5)),
        translate('n_domains', formatNumber(15)),
        translate('n_searches_day', formatNumber(900)),
        translate('competitor_per_domain', formatNumber(15)),
        translate('scans_per_domain', formatNumber(10000)),
        translate('kw_per_domain', formatNumber(300)),
        translate('unlimited_locations_per_domain'),
        translate('yes_export_img_csv_pdf'),
      ],
    },
  }

  return (
    <Wrapper>
      <Header>
        <ArrowButton
          onClick={() => {
            if (tier === 'tier2') onChange('tier1')
            else if (tier === 'tier3') onChange('tier2')
          }}
          disabled={tier === 'tier1'}
        >
          <ArrowLeft />
        </ArrowButton>
        <HeaderText>
          <span>{PLANS[tier].title}</span>
          {tier === 'tier1' && (
            <>
              <EllipseIcon style={{ margin: '-1px 7px 0 7px' }} />
              <span
                style={{
                  fontSize: ['pt', 'es'].includes(lang) ? '12px' : '13px',
                  lineHeight: 1,
                  color: palette.blue,
                  wordBreak: 'break-word',
                }}
              >
                {translate('best_value')}
              </span>
            </>
          )}
        </HeaderText>
        <ArrowButton
          onClick={() => {
            if (tier === 'tier1') onChange('tier2')
            else if (tier === 'tier2') onChange('tier3')
          }}
          disabled={tier === 'tier3'}
        >
          <ArrowRight />
        </ArrowButton>
      </Header>
      <div style={{ padding: '10px 16px' }}>
        <Text fontSize="14px" lineHeight="19.6px">
          {PLANS[tier].description}
        </Text>
        <div
          style={{
            marginTop: '10px',
          }}
        >
          {PLANS[tier].lists.map((benefit) => (
            <div
              key={benefit}
              style={{
                marginBottom: '8px',
                display: 'flex',
                alignItems: 'flex-end',
              }}
            >
              <CheckMark style={{ marginRight: '8px' }} />
              <Text
                color={palette.darkGray70}
                fontSize="12px"
                lineHeight="12px"
              >
                {benefit}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </Wrapper>
  )
}
